import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilter1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-1, sort"><path d="M6.75 3C4.67724 3 3 4.68583 3 6.7552C3 7.74919 3.39468 8.70535 4.09835 9.40901L8.34099 13.6517C8.76295 14.0736 9 14.6459 9 15.2426V21.25C9 21.4844 9.10956 21.7053 9.29615 21.8471C9.48275 21.9889 9.72491 22.0354 9.95073 21.9726L14.4507 20.7226C14.7753 20.6325 15 20.3369 15 20V15.2426C15 14.6459 15.2371 14.0736 15.659 13.6517L19.9016 9.40901C20.6053 8.70534 21 7.74919 21 6.7552C21 4.68583 19.3228 3 17.25 3H6.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFilter1;
